import { registerBrick, BrickContext, Config, UIBrick } from 'olympe';
import ReactDOM from 'react-dom';
import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import { _theme } from '../shared/_theme';
import { ThemeProvider } from '@mui/material/styles';
import { PropTypes } from 'prop-types';
import { Tabs, Tab } from '@mui/material'
import {
    DataGridPro,
    GridToolbarContainer,
    GridToolbar,
    LicenseInfo,
    GRID_CHECKBOX_SELECTION_COL_DEF,
} from '@mui/x-data-grid-pro';


import { CircularProgress } from "@mui/material";
import { fetchRiskCrisis } from './RiskCrisis';
import { combineLatest } from 'rxjs';
import { map, startWith, distinctUntilChanged, shareReplay, filter, auditTime } from 'rxjs/operators';
import { crisisRiskLevelColumns, getRowId, materialsDataColumns, riskLevelColumns } from './_materialsTable.jsx';
import { createEvents } from '../shared/_helpers';

/**
 * Component that is used on the Identification tab of the Risk & Crisis App
 */
export default class RCTable extends UIBrick {
    /**
     * This method runs when the brick is ready in the HTML DOM.
     * @override
     * @param {!BrickContext} $
     * @param {!Element} elementDom
     */
    draw($, elementDom) {
        // Add the License for the DataGrid Pro
        const licenseKey = Config.getParameter('uiAppValues.datagrid_license')
        LicenseInfo.setLicenseKey(licenseKey);

        const events = createEvents([
            {
                name: "throwError",
                event: $.getEvent("Throw Error"),
                before: (event, values) => {
                    $.getProperty("Error Message").set(values);
                },
            },
        ]);

        // parse filters data
        const standardFiltersObservable = $.getProperty("Filters").observe().pipe(
            map((filters) => JSON.parse(filters || '{}')),
            distinctUntilChanged((prev, next) => JSON.stringify(prev) === JSON.stringify(next)),
            startWith({}),
            shareReplay(1)
        );

        // TODO could be reworked into using JSON object instead of strings for the values
        const topFiltersObservable = $.getProperty('Top Event Value')
            .observe()
            .pipe(
                map((filters) => {
                    if (filters && filters !== '') {
                        const topFiltersData = JSON.parse(filters);
                        const geoRiskLevels = topFiltersData.geoRiskLevels
                            ? topFiltersData.geoRiskLevels
                            : null;
                        const financialRiskLevels = topFiltersData.financialRiskLevels
                            ? topFiltersData.financialRiskLevels
                            : null;
                        const sourcingFlexibilityRiskLevels =
                            topFiltersData.sourcingFlexibilityRiskLevels
                                ? topFiltersData.sourcingFlexibilityRiskLevels
                                : null;
                        const supplierOTIFRiskLevels =
                            topFiltersData.supplierOTIFRiskLevels
                                ? topFiltersData.supplierOTIFRiskLevels
                                : null;
                        const planningRiskLevels = topFiltersData.planningRiskLevels
                            ? topFiltersData.planningRiskLevels
                            : null;
                        const resExtremeWeatherRiskLevels = topFiltersData.resExtremeWeatherRiskLevels
                            ? topFiltersData.resExtremeWeatherRiskLevels
                            : null;
                        const resGeopoliticalRiskLevels = topFiltersData.resGeopoliticalRiskLevels
                            ? topFiltersData.resGeopoliticalRiskLevels
                            : null;
                        const resPortCongestionRiskLevels = topFiltersData.resPortCongestionRiskLevels
                            ? topFiltersData.resPortCongestionRiskLevels
                            : null;
                        const resOthersRiskLevels = topFiltersData.resOthersRiskLevels
                            ? topFiltersData.resOthersRiskLevels
                            : null;
                        const resQualityRiskLevels = topFiltersData.resQualityRiskLevels
                            ? topFiltersData.resQualityRiskLevels
                            : null;
                        // Quality Risk level filter card
                        const qualityRiskLevel = topFiltersData.RISK_LEVEL
                            ? topFiltersData.RISK_LEVEL
                            : null;

                        return {
                            //...topFilters,
                            geoRiskLevels,
                            financialRiskLevels,
                            sourcingFlexibilityRiskLevels,
                            supplierOTIFRiskLevels,
                            planningRiskLevels,
                            qualityRiskLevel,
                            resExtremeWeatherRiskLevels,
                            resGeopoliticalRiskLevels,
                            resPortCongestionRiskLevels,
                            resOthersRiskLevels,
                            resQualityRiskLevels,
                        };
                    }

                    return {};
                }),
                distinctUntilChanged((prev, next) => JSON.stringify(prev) === JSON.stringify(next)),
                startWith({}),
                shareReplay(1)
            );

        combineLatest([standardFiltersObservable, topFiltersObservable])
            .pipe(
                auditTime(0),
                distinctUntilChanged(
                    ([prevStandard, prevTop], [nextStandard, nextTop]) =>
                        JSON.stringify(prevStandard) === JSON.stringify(nextStandard) &&
                        JSON.stringify(prevTop) === JSON.stringify(nextTop)
                )
            )
            .subscribe(([standardFilters, topFilters]) => {
            ReactDOM.render(
                <RCTable.Component
                    {...events}
                    $={$}
                    standardFilters={standardFilters}
                    topFilters={topFilters}
                />,
                elementDom
            );
        });
    }
}

/**
 *
 * @param {Object} props
 * @param {!BrickContext} props.$
 * @param {Object} props.standardFilters
 * @param {Object} props.topFilters
 * @param {function(Event, string)} props.throwError
 * @return {JSX.Element}
 * @constructor
 */
RCTable.Component = (props) => {
    const [componentHeight, setComponentHeight] = useState(0);
    const [rows, setRows] = useState([]);
    const [additionalRows, setAdditionalRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [moreRecordsAvailable, setMoreRecordsAvailable] = useState({});
    const [tabValue, setTabValue] = useState(0)
    const rowIndex = useRef(0);
    const [outageIndicator, setOutageIndicator] = useState(sessionStorage.getItem("Outage_indicator_session"))

    console.log(":: outage Indicator ::::", outageIndicator)
    useEffect(() => {
        // 2 hours in milliseconds: 2 * 60 * 60 * 1000
        const TWO_HOURS = 7200000;

        const intervalId = setInterval(() => {
            // Replace this with whatever logic or API call you need
            setOutageIndicator(sessionStorage.getItem("Outage_indicator_session"));
        }, TWO_HOURS);

        // Cleanup: clear the interval when the component unmounts
        return () => clearInterval(intervalId);
    }, []);
    useLayoutEffect(() => {
        const riskAndCrisisTables = document.getElementById("riskAndCrisisTables");
        if (riskAndCrisisTables !== null) {
            setComponentHeight(riskAndCrisisTables.parentElement.clientHeight);
        }
    });

    const fetchRC = async (stdFilters, topFilters) => {
        setLoading(true);
        const data = await fetchRiskCrisis(stdFilters, topFilters, 0);
        if (data.error) {
            setLoading(false);
            props.throwError(null, data.message);
        } else if (data["materials"].length < 1) {
            setLoading(false);
            props.throwError(null, "Empty response received. Please try again with different filters");
        } else {
            setMoreRecordsAvailable(data.moreRecordsAvailable);
            const newRows = data["materials"].map(function (row) {
                return {
                    ...row,
                    id: getRowId(row),
                };
            });
            setRows(newRows);
            setAdditionalRows([]);
        }
        setLoading(false);
    };

    const fetchMore = async (stdFilters, topFilters, startIndex) => {
        const data = await fetchRiskCrisis(stdFilters, topFilters, startIndex);

        if (data.error) {
            console.error(data.message);
            props.throwError(null, data.message);
        } else {
            setMoreRecordsAvailable(data.moreRecordsAvailable);
            const newRows = data["materials"].map(function (row) {
                return {
                    ...row,
                    id: getRowId(row),
                };
            });
            setAdditionalRows((prev) => [...prev, ...newRows]);
        }
    };

    useEffect(() => {
        rowIndex.current = 0;
        fetchRC(props.standardFilters, props.topFilters);
    }, [props.standardFilters, props.topFilters]);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    }
    const riskLevelPinnedColumns = [...riskLevelColumns(), ...crisisRiskLevelColumns(props.$)];

    const visibleColumn = tabValue === 0 ? riskLevelPinnedColumns.slice(0, 6) : riskLevelPinnedColumns.slice(6, 11);

    const columnsMaterial = [
        ...materialsDataColumns(props.$),
        ...visibleColumn,
    ];

    const CustomToolbar = () => {
        return (
            <GridToolbarContainer style={{ justifyContent: 'flex-end' }}>
                <GridToolbar />
                <Tabs value={tabValue} onChange={handleTabChange} >
                    <Tab sx={{ textTransform: "none", fontSize: '1rem' }} label="Risk type" />
                    <Tab sx={{ textTransform: "none", fontSize: '1rem' }} label="Potential crisis alert" />
                </Tabs>
            </GridToolbarContainer>
        );
    };

    return (
        <ThemeProvider theme={_theme}>
            <div className={"rc-tables"} id={"riskAndCrisisTables"}>
                {loading || rows.length === 0 ? (
                    <CircularProgress
                        style={{
                            position: "absolute",
                            top: "48%",
                            left: "48%",
                            width: "4%",
                            height: "auto",
                        }}
                    />
                ) : (
                    <div style={{ display: "flex", width: "100%" }}>
                        <div className={"rc-data-table"}>
                            <div
                                className={"rc-data-table-scroller"}
                            >
                                <DataGridPro
                                    rows={rows.concat(additionalRows)}
                                    classes={{
                                        virtualScroller: 'with-scrollbar',
                                    }}
                                    columns={columnsMaterial}
                                    checkboxSelection
                                    isRowSelectable={() => Number(outageIndicator) === 0}
                                    hideFooter
                                    initialState={{
                                        pinnedColumns: {
                                            left: [
                                                GRID_CHECKBOX_SELECTION_COL_DEF.field,
                                            ],
                                            right: [
                                                "geoRiskLevel",
                                                "financialRiskLevel",
                                                "sourcingFlexibilityRiskLevel",
                                                "supplierOTIFRiskLevel",
                                                "planningRiskLevel",
                                                "RISK_LEVEL",
                                                "resExtremeWeatherRiskLevel",
                                                "resPortCongestionRiskLevel",
                                                "resQualityRiskLevel",
                                                "resGeopoliticalRiskLevel",
                                                "resOthersRiskLevel",
                                            ],
                                        },
                                    }}
                                    onSelectionModelChange={(selectionModel) => {
                                        // Data with selected objects
                                        const allRows = rows.concat(additionalRows);
                                        props.$.set('Crisis Creation Data', JSON.stringify({
                                            moreRecordsAvailable: moreRecordsAvailable,
                                            topFilters: props.topFilters,
                                            standardFilters: props.standardFilters,
                                            checkedItems: allRows.filter(row => selectionModel.includes(row.id))
                                        }));

                                        // Last selected object
                                        const lastClickedRow = selectionModel.slice(-1).pop();

                                        const selectedRow = allRows.find(row => row.id === lastClickedRow);

                                        props.$.set('Selected Object', selectedRow);
                                        props.$.set('Selected psEmail', selectedRow?.psEmail);
                                        props.$.set('Selected pmEmail', selectedRow?.pmEmail);

                                        // Trigger event
                                        props.$.trigger('On Selection Changed');
                                    }}
                                    onRowsScrollEnd={() => {
                                        if (moreRecordsAvailable === true) {
                                            rowIndex.current =
                                                rowIndex.current + 500;
                                            fetchMore(
                                                props.standardFilters,
                                                props.topFilters,
                                                rowIndex.current
                                            );
                                        }
                                    }}
                                    components={{
                                        Toolbar: CustomToolbar,
                                    }}
                                    disableDensitySelector={true}
                                    disableColumnSelector={true}
                                    disableColumnFilter={true}
                                    disableSelectionOnClick={false}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </ThemeProvider>
    );
};

RCTable.Component.propTypes = {
    $: PropTypes.object,
    standardFilters: PropTypes.object,
    topFilters: PropTypes.object,
    enableEdition: PropTypes.bool,
    enableQuickSearch: PropTypes.bool,
    showRiskLevelPanel: PropTypes.bool,
    disableSelectionForMaterials: PropTypes.array,
    onSelectionChange: PropTypes.func,
    throwError: PropTypes.func,
};

registerBrick("017b1bf1d1d35d5e9449", RCTable);